export default __webpack_public_path__ + "static/media/Logo.b0217cca.svg";